<div>
    <span class="icon is-huge"><i class="tri-click-collect-2h"></i></span>
    <div>
        <p>Hélas les accessoires ne sont pas encore disponibles en Click &amp; Collect 😕</p>
    </div>

    <div class="columns mb-2 mt-2">
        <div class="column">
            <p class="text is-level-1">
                Je garde le mode Click &amp; Collect et découvre les accessoires disponibles en boutique.
            </p>
        </div>
        <div class="column">
            <p class="text is-level-1">
                Je me fais livrer cet accessoire avec mon téléphone, à domicile ou en Point Relais.
            </p>
        </div>
    </div>
    <ng-template #customModalFooter>
        <div class="buttons">
            <div>
                <a
                    data-tc-action="Clic_selection"
                    data-tc-categorie="Popin_click_and_collect"
                    data-tc-nom="Garder_le_click_and_collect"
                    class="button is-conversion"
                    (click)="continue()"
                >
                    Garder le Click &amp; Collect
                </a>
            </div>
            <div>
                <a
                    class="button is-primary"
                    data-tc-action="Clic_selection"
                    data-tc-categorie="Popin_click_and_collect"
                    data-tc-nom="Me_faire_livrer"
                    (click)="validate()"
                >
                    Me faire livrer
                </a>
            </div>
        </div>
    </ng-template>
</div>
